import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { SiteStore } from '@core/site/site.store';

@Component({
  selector: 'app-drawer-nav',
  imports: [RouterLink, RouterLinkActive, MatButtonModule, MatIconModule],
  templateUrl: './drawer-nav.component.html',
  styleUrl: './drawer-nav.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DrawerNavComponent {
  protected site = inject(SiteStore);
  protected auth = inject(AuthenticationService);

  protected close(): void {
    this.site.closeLeftDrawer();
  }
}
